import { INSPECTION_WARNING_THRESHOLD_KM } from '@/constants/inspection-warning-threshold-km.constant';
import type { Car } from '@/entities/cars/car.entity';
import { type MaybeRefOrGetter, toValue } from '@vueuse/core';
import { computed } from 'vue';

export const useCurrentInspectionCycleMileage = (car: MaybeRefOrGetter<Car>) => {
  return computed(() => getCurrentInspectionCycleMileage(toValue(car)));
};

export const getCurrentInspectionCycleMileage = (car: Car) => {
  return (
    Math.floor(
      (car.milage + INSPECTION_WARNING_THRESHOLD_KM) / car.vehicleType.inspectionIntervalInKm,
    ) * car.vehicleType.inspectionIntervalInKm
  );
};

export const getNextInspectionDueOdometer = (
  car: Car,
  lastCompletedInspectionMilageEnd: number | null | undefined,
): number => {
  const interval = car.vehicleType.inspectionIntervalInKm;
  if (interval <= 0 || Number.isNaN(interval)) {
    return getCurrentInspectionCycleMileage(car);
  }

  const last =
    lastCompletedInspectionMilageEnd != null && !Number.isNaN(lastCompletedInspectionMilageEnd)
      ? lastCompletedInspectionMilageEnd
      : null;

  if (last !== null) {
    let next = last + interval;
    while (next <= car.milage) {
      next += interval;
    }
    return next;
  }

  const initialMilage = car.initialMilage ?? 0;
  let next = (Math.floor(initialMilage / interval) + 1) * interval;
  while (next <= car.milage) {
    next += interval;
  }
  return next;
};
